import styled from 'styled-components'
import Typography from '../Typography'

export default styled(Typography).attrs({ as: 'h2' })`
  margin-bottom: ${({ theme }) => theme.spacing.km2};
`
